import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useRequirementDetailWorkflowsContextValue } from '../../../context/RequirementDetailWorkflowProvider'

type RestoreQuestionFlowContextState = {
  state: {
    question: NonNullable<
      ReturnType<
        typeof useRequirementDetailWorkflowsContextValue
      >['restoreQuestionFlow']['data']
    >['question']
    isPending: boolean
    isError: boolean
    errorMessage: string | undefined
  }
  actions: {
    confirm: () => void
  }
}

const [RestoreQuestionFlowContext, useRestoreQuestionFlowContextValue] =
  createContext<RestoreQuestionFlowContextState>({
    name: 'RestoreQuestionFlowContext',
  })

export const RestoreQuestionFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    restoreQuestionFlow: { isOpen, close, data: flowData },
  } = useRequirementDetailWorkflowsContextValue()

  if (isOpen && !flowData) {
    throw new Error(
      'Unable to find restore question flow data. Please report this error to the engineering team.'
    )
  }

  if (!flowData) {
    return null
  }

  const value: RestoreQuestionFlowContextState = {
    state: {
      question: flowData.question,
      isPending: false,
      isError: false,
      errorMessage: undefined,
    },
    actions: {
      confirm: close,
    },
  }

  return (
    <RestoreQuestionFlowContext.Provider value={value}>
      {children}
    </RestoreQuestionFlowContext.Provider>
  )
}

export { useRestoreQuestionFlowContextValue }
